// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { Check } from "lucide-react";
// import { format, parseISO } from "date-fns";
// import * as XLSX from "xlsx";

// const APPROVAL_RANGES = [
//   { id: "1", label: "5 Lakhs", value: "500000" },
//   { id: "2", label: "7 Lakhs", value: "700000" },
//   { id: "3", label: "10 Lakhs", value: "1000000" },
// ];

// const EVENT_TYPES = [
//   { id: "1", label: "Demo Cars", value: "0" },
//   { id: "2", label: "Pre-Owned Cars", value: "1" },
// ];

// function TextDisplayCopy({ link }) {
//   const [text, setText] = useState(link);
//   const [isCopied, setIsCopied] = useState(false);

//   const handleCopy = () => {
//     navigator.clipboard.writeText(text).then(() => {
//       setIsCopied(true);
//       setTimeout(() => setIsCopied(false), 1500);
//     });
//   };

//   const styles = {
//     container: {
//       maxWidth: "800px",
//       margin: "0 auto",
//       display: "flex",
//       boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
//     },
//     textDisplay: {
//       flexGrow: 1,
//       padding: "12px",
//       backgroundColor: "white",
//       border: "1px solid #ccc",
//       borderRight: "none",
//       whiteSpace: "nowrap",
//       overflow: "hidden",
//       textOverflow: "ellipsis",
//       color: "#333",
//     },
//     copyButton: {
//       width: "48px",
//       padding: "12px",
//       backgroundColor: isCopied ? "#22c55e" : "#ef4444",
//       color: "white",
//       border: "none",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "background-color 0.3s ease",
//     },
//     icon: {
//       width: "20px",
//       height: "20px",
//       animation: isCopied ? "pulse 1.5s ease" : "none",
//     },
//   };

//   return (
//     <>
//       <style>{`
//         @keyframes pulse {
//           0% { transform: scale(1); }
//           25% { transform: scale(1.2); }
//           50% { transform: scale(1); }
//           75% { transform: scale(1.1); }
//           100% { transform: scale(1); }
//         }
//       `}</style>
//       <div style={styles.container}>
//         <div style={styles.textDisplay}>{text}</div>
//         <button
//           onClick={handleCopy}
//           style={styles.copyButton}
//           aria-label="Copy text"
//         >
//           {isCopied ? (
//             <svg
//               style={styles.icon}
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M5 13l4 4L19 7"
//               ></path>
//             </svg>
//           ) : (
//             <svg
//               style={styles.icon}
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
//               ></path>
//             </svg>
//           )}
//         </button>
//       </div>
//     </>
//   );
// }

// const WeeklyCalendar = ({ selectedDate, onDateSelect, availableSlots }) => {
//   const weekDays = Object.keys(availableSlots)
//     .sort((a, b) => new Date(a) - new Date(b))
//     .map((date) => parseISO(date));

//   return (
//     <div
//       className="d-flex gap-2"
//       style={{ overflowX: "auto", maxWidth: "100%" }}
//     >
//       {weekDays.map((date) => {
//         const dateKey = format(date, "yyyy-MM-dd");
//         const hasSlots = availableSlots[dateKey]?.length > 0;
//         const carCount = availableSlots[dateKey]?.[0]?.carCountBelow1176 || 0;

//         return (
//           <button
//             key={dateKey}
//             onClick={() => {
//               console.log(`Selected date: ${dateKey}`);
//               hasSlots && onDateSelect(date);
//             }}
//             disabled={!hasSlots}
//             className={`p-4 text-black ${
//               selectedDate?.toDateString() === date.toDateString()
//                 ? "bg-danger text-white"
//                 : "bg-white hover:bg-light"
//             }`}
//             style={
//               hasSlots
//                 ? { border: "2px solid #ee373b", borderRadius: "10px" }
//                 : { cursor: "not-allowed", opacity: 0.5, borderRadius: "10px" }
//             }
//           >
//             <div className="text-sm">{format(date, "EEE")}</div>
//             <div className="text-lg font-semibold">{format(date, "d")}</div>
//             <div className="text-sm">Car Count: {carCount}</div>
//           </button>
//         );
//       })}
//     </div>
//   );
// };

// const TimeSlots = ({ timeSlots, onTimeSlotSelect }) => {
//   return (
//     <div
//       className="d-flex flex-wrap gap-2 mt-6 mx-lg-10"
//       style={{ overflowY: "auto" }}
//     >
//       {timeSlots.map((slot, index) => (
//         <button
//           key={slot.time}
//           onClick={() => {
//             console.log(`Selected time slot: ${slot.time}`);
//             onTimeSlotSelect(index);
//           }}
//           className={`p-3 transition text-black ${
//             slot.selected ? "bg-danger text-white" : "bg-white hover:bg-light"
//           }`}
//           style={{ border: "2px solid #ee373b" }}
//         >
//           {slot.time}
//         </button>
//       ))}
//     </div>
//   );
// };


// const PrivateLenderEventCreation = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     selectedDate: null,
//     selectedTimeSlots: null,
//     approvalLimit: "",
//     duration: "",
//   });
//   const [isComplete, setIsComplete] = useState(false);
//   const [availableSlots, setAvailableSlots] = useState({});
//   const [users, setUsers] = useState([]);
//   const [communityNo, setCommunityNo] = useState(null);
//   const [eventTitle, setEventTitle] = useState("");
//   const [location, setLocation] = useState("");
//   const [carCount, setCarCount] = useState(0);
//   const [link, setLink] = useState("");
//   const [isStepValid, setIsStepValid] = useState(false);
//   const [durationOptions, setDurationOptions] = useState([]);
//   const [isCreating, setIsCreating] = useState(false);
//   const [newUser, setNewUser] = useState({
//     userID: "",
//     preapprovedLimitValue: "",
//   });
//   const [errorMessage, setErrorMessage] = useState("");
//   const [eventType, setEventType] = useState("");
//   const [inputMethod, setInputMethod] = useState("manual");
//   const navigate = useNavigate();

//   useEffect(() => {
//     console.log("Fetching community number and lender info");
//     const communityNumber = parseInt(Cookies.get("adminCommunityNO"), 10);
//     setCommunityNo(communityNumber);
//     const lenderInfoRaw = Cookies.get("adminLenderInfo") || "";
//     const [firstName = "", lastName = ""] = lenderInfoRaw.split("_");
//     const lenderInfo = `${firstName} ${lastName}`.trim();
//     const loc = Cookies.get("adminLocation") || "";
//     setLocation(loc);
//     const eventTitles = `${lenderInfo} ${loc}`.trim();
//     setEventTitle(eventTitles);

//     fetch(
//       `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/showAvailableSlotsForNextWeek?location=${loc}`,
//       {
//         credentials: "include",
//         headers: {
//           "X-Full-URL": window.location.href,
//         },
//       }
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Available slots fetched:", data);
//         setAvailableSlots(data);
//       })
//       .catch((error) => {
//         console.error("Error fetching available slots:", error);
//       });
//   }, []);

//   useEffect(() => {
//     if (formData.selectedTimeSlots) {
//       const selectedSlot = formData.selectedTimeSlots.find(
//         (slot) => slot.selected
//       );
//       if (selectedSlot) {
//         console.log(
//           `Fetching duration options for slot ID: ${selectedSlot.id}`
//         );
//         fetch(
//           `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/duration-options?slotId=${selectedSlot.id}`,
//           {
//             credentials: "include",
//             headers: {
//               "X-Full-URL": window.location.href,
//             },
//           }
//         )
//           .then((response) => {
//             if (!response.ok) {
//               throw new Error("Network response was not ok");
//             }
//             return response.json();
//           })
//           .then((data) => {
//             console.log("Duration options fetched:", data);
//             const formattedOptions = data.map((option, index) => {
//               const minutes = parseInt(option.replace(/\D/g, ""));
//               return {
//                 id: (index + 1).toString(),
//                 label: option,
//                 value: minutes.toString(),
//               };
//             });
//             setDurationOptions(formattedOptions);
//           })
//           .catch((error) => {
//             console.error("Error fetching duration options:", error);
//             const fallbackOptions = [
//               { id: "1", label: "5 Mins", value: "5" },
//               { id: "2", label: "10 Mins", value: "10" },
//               { id: "3", label: "15 Mins", value: "15" },
//               { id: "4", label: "30 Mins", value: "30" },
//               { id: "5", label: "45 Mins", value: "45" },
//               { id: "6", label: "1 Hour", value: "60" },
//             ];
//             setDurationOptions(fallbackOptions);
//           });
//       }
//     }
//   }, [formData.selectedTimeSlots]);

//   useEffect(() => {
//     console.log(`Validating step ${currentStep}`);
//     if (currentStep === 1) {
//       const isValid = !!eventType;
//       setIsStepValid(isValid);
//     } else if (currentStep === 2) {
//       const isValid =
//         formData.selectedDate &&
//         formData.selectedTimeSlots?.some((slot) => slot.selected);
//       setIsStepValid(isValid);
//     } else if (currentStep === 3) {
//       const isValid = formData.approvalLimit && formData.duration;
//       setIsStepValid(isValid);
//     } else if (currentStep === 4) {
//       const isValid = users.length > 0;
//       setIsStepValid(isValid);
//     } else if (currentStep === 5) {
//       setIsStepValid(true);
//     }
//   }, [formData, users, currentStep, eventType]);

//   const handleDateSelect = (date) => {
//     const dateKey = format(date, "yyyy-MM-dd");
//     const slotsForDate = availableSlots[dateKey] || [];
//     const formattedTimeSlots = slotsForDate.map((slot) => ({
//       time: slot.availebleSlot,
//       selected: false,
//       id: slot.slotId,
//     }));
//     setFormData((prev) => ({
//       ...prev,
//       selectedDate: date,
//       selectedTimeSlots: formattedTimeSlots,
//     }));
//     const carCount = slotsForDate[0]?.carCountBelow1176 || 0;
//     setCarCount(carCount);
//   };

//   const handleTimeSlotSelect = (index) => {
//     const updatedSlots = formData.selectedTimeSlots.map((slot, i) => ({
//       ...slot,
//       selected: i === index,
//     }));
//     setFormData((prev) => ({
//       ...prev,
//       selectedTimeSlots: updatedSlots,
//     }));
//     setFormData((prev) => ({
//       ...prev,
//       duration: "",
//     }));
//     setCurrentStep(3);
//   };

//   const handleApprovalLimitChange = (e) => {
//     const selectedLimit = e.target.value;
//     console.log(`Selected approval limit: ${selectedLimit}`);
//     setFormData((prev) => ({ ...prev, approvalLimit: selectedLimit }));

//     setNewUser((prev) => ({
//       ...prev,
//       preapprovedLimitValue: selectedLimit,
//     }));
//   };

//   const handleDurationChange = (e) => {
//     console.log(`Selected duration: ${e.target.value}`);
//     setFormData((prev) => ({ ...prev, duration: e.target.value }));
//   };

//   const handleAddUser = () => {
//     if (!newUser.userID || !newUser.preapprovedLimitValue) {
//       return;
//     }
//     const userExists = users.some((user) => user.userID === newUser.userID);
//     if (userExists) {
//       setErrorMessage("User with this ID already exists");
//       return;
//     }
//     setErrorMessage("");
//     setUsers([
//       ...users,
//       {
//         name: "private buyer",
//         userID: newUser.userID,
//         preapprovedLimitValue: Number(newUser.preapprovedLimitValue),
//       },
//     ]);
//     setNewUser({
//       userID: "",
//       preapprovedLimitValue: formData.approvalLimit || "",
//     });
//   };

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       console.log(`File uploaded: ${file.name}`);
//       const reader = new FileReader();

//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: "array" });
//         const worksheet = workbook.Sheets[workbook.SheetNames[0]];

//         // Get raw data with headers
//         const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//         if (rawData.length === 0) {
//           console.warn("Empty Excel file.");
//           return;
//         }

//         // Normalize headers
//         const headers = rawData[0].map((h) =>
//           typeof h === "string" ? h.toLowerCase().trim() : ""
//         );

//         // Convert raw rows to objects using normalized headers
//         const jsonData = rawData.slice(1).map((row) => {
//           const obj = {};
//           headers.forEach((key, index) => {
//             obj[key] = row[index];
//           });
//           return obj;
//         });

//         // Filter and process rows with valid numeric data
//         const processedUsers = jsonData
//           .filter((row) => {
//             const value = row["preapproved loan value"];
//             const userID = row["customer ref id"];
//             return (
//               value !== undefined &&
//               value !== null &&
//               value !== "" &&
//               !isNaN(Number(value)) &&
//               userID !== undefined &&
//               userID !== null &&
//               userID !== ""
//             );
//           })
//           .map((row) => ({
//             name: "private buyer",
//             preapprovedLimitValue: Number(row["preapproved loan value"]),
//             userID: row["customer ref id"],
//           }));

//         console.log("Processed users from file:", processedUsers);
//         setUsers(processedUsers);
//       };

//       reader.readAsArrayBuffer(file);
//     }
//   };

//   const handleNext = () => {
//     console.log(`Moving to next step from step ${currentStep}`);
//     if (currentStep < 5) {
//       setCurrentStep((prev) => prev + 1);
//     } else {
//       handleCreateEvent();
//     }
//   };

//   const handleBack = () => {
//     console.log(`Moving back to step ${currentStep - 1}`);
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   const handleCreateEvent = () => {
//     console.log("Creating event...");
//     setIsCreating(true);
//     const selectedTimeSlot = formData.selectedTimeSlots.find(
//       (slot) => slot.selected
//     );
//     const startDate = new Date(formData.selectedDate);
//     const [hours, minutes] = selectedTimeSlot.time.split(":").map(Number);
//     startDate.setHours(hours, minutes, 0, 0);
//     const endDate = new Date(startDate);
//     endDate.setMinutes(endDate.getMinutes() + parseInt(formData.duration, 10));

//     const formatDateTime = (date) => {
//       const pad = (n) => n.toString().padStart(2, "0");
//       const year = date.getFullYear();
//       const month = pad(date.getMonth() + 1);
//       const day = pad(date.getDate());
//       const hours = pad(date.getHours());
//       const minutes = pad(date.getMinutes());
//       const seconds = pad(date.getSeconds());
//       return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//     };

//     const eventData = {
//       eventTitle: eventTitle + (eventType == 0 ? " - **DEMO CARS**" : ""),
//       location: location,
//       startDateAndTime: formatDateTime(startDate),
//       endDateAndTime: formatDateTime(endDate),
//       userApprovedLimit: formData.approvalLimit,
//       communityNo: communityNo,
//       auctionSlotId: selectedTimeSlot.id,
//       duration: formData.duration,
//       eventType: eventType,
//     };

//     console.log("Event data to be sent:", eventData);

//     const formDataToSend = new FormData();
//     formDataToSend.append("communityNo", communityNo);
//     formDataToSend.append("users", JSON.stringify(users));
//     formDataToSend.append("eventDetails", JSON.stringify(eventData));
//     formDataToSend.append("vehicleType",Number(eventType));

//     fetch(
//       `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/privateLender/createEventWithUsers`,
//       {
//         method: "POST",
//         body: formDataToSend,
//         credentials: "include",
//         headers: {
//           "X-Created-By": "PRIVATE LENDER",
//         },
//       }
//     )
//       .then((response) => {
//         console.log("Response status:", response.status);
//         return response.json();
//       })
//       .then((data) => {
//         console.log("Event creation response:", data);
//         if (data.message.includes("Event created successfully")) {
//           if (data.link) {
//             setLink(data.link);
//           }
//           setIsComplete(true);
//         } else {
//           console.error("Error creating event:", data);
//         }
//       })
//       .catch((error) => {
//         console.error("Error creating event:", error);
//       })
//       .finally(() => {
//         setIsCreating(false);
//       });
//   };

//   const renderStep = () => {
//     return (
//       <div>
//         {currentStep === 1 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Select Vehicle Type
//             </h2>
//             <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
//               <div className="mb-3">
//                 <div className="d-flex justify-content-center gap-5 mt-5">
//                   {EVENT_TYPES.map((type) => (
//                     <button
//                       className="event-type-button"
//                       key={type.id}
//                       value={type.value}
//                       onClick={(e) => {
//                         setEventType(type.value);
//                         setCurrentStep(currentStep+1)
//                       }}
//                     >
//                       {type.label}
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {currentStep === 2 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Select Date & Time
//             </h2>
//             <div className="d-flex flex-column gap-5 justify-content-center align-items-center">
//               <WeeklyCalendar
//                 selectedDate={formData.selectedDate}
//                 onDateSelect={handleDateSelect}
//                 availableSlots={availableSlots}
//               />
//               {formData.selectedDate && (
//                 <TimeSlots
//                   timeSlots={formData.selectedTimeSlots}
//                   onTimeSlotSelect={handleTimeSlotSelect}
//                 />
//               )}
//               {carCount > 0 && <div className="mt-4"></div>}
//             </div>
//           </div>
//         )}

//         {currentStep === 3 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Set Approval Limit & Duration
//             </h2>
//             <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
//               <div className="mb-3">
//                 <label htmlFor="approvalLimit" className="form-label">
//                   Approval Limit
//                 </label>
//                 <select
//                   id="approvalLimit"
//                   value={formData.approvalLimit}
//                   style={{ maxWidth: "300px" }}
//                   onChange={handleApprovalLimitChange}
//                   className="form-select"
//                 >
//                   <option value="">Select Pre-Approval Limit</option>
//                   {APPROVAL_RANGES.map((range) => (
//                     <option key={range.id} value={range.value}>
//                       {range.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="mb-3">
//                 <label htmlFor="duration" className="form-label">
//                   Duration of Event
//                 </label>
//                 <select
//                   id="duration"
//                   value={formData.duration}
//                   onChange={handleDurationChange}
//                   style={{
//                     maxWidth: "300px",
//                     maxHeight: "100px",
//                     overflowY: "auto",
//                     scrollbarColor: "#ee373b #ffffff",
//                   }}
//                   className="form-select"
//                 >
//                   <option value="">Select Duration</option>
//                   {durationOptions.length > 0 ? (
//                     durationOptions.map((duration) => (
//                       <option key={duration.id} value={duration.value}>
//                         {duration.label}
//                       </option>
//                     ))
//                   ) : (
//                     <>
//                       <option value="5">5 Mins</option>
//                       <option value="10">10 Mins</option>
//                       <option value="15">15 Mins</option>
//                       <option value="30">30 Mins</option>
//                       <option value="45">45 Mins</option>
//                       <option value="60">1 Hour</option>
//                       <option value="120">2 Hours</option>
//                       <option value="180">3 Hours</option>
//                       <option value="240">4 Hours</option>
//                     </>
//                   )}
//                 </select>
//               </div>
//             </div>
//           </div>
//         )}

//         {currentStep === 4 && (
//           <div className="container py-3">
//             <div className="d-flex justify-content-between align-items-center mb-4">
//               <span className="d-none d-lg-block" style={{width: "100px"}}></span>
           
//               <h2 className="mb-0 d-none d-lg-block" style={{ color: "#ee373b" }}>
//                 Add Customer Data
//               </h2>

//               {/* Mobile / small to medium screens (below lg) */}
//               <h5 className="mb-0 d-block d-lg-none" style={{ color: "#ee373b" }}>
//                 Add Customer Data
//               </h5>
//               {/* Single Toggle Button */}
//               <button
//                 className="btn btn-danger"
//                 style={{width: "100px"}}
//                 onClick={() =>
//                   {
//                     setInputMethod(inputMethod === "manual" ? "excel" : "manual")
//                     setUsers([]);
//                   }
//                 }
//               >
//                 {inputMethod === "manual"
//                   ? "Excel Upload"
//                   : "Manual Input"}
//               </button>
//             </div>

//             {/* Manual Input Section */}
//             {inputMethod === "manual" && (
//               <div className="p-2 mb-1">
//                 <div className="d-flex align-items-end d-flex justify-content-center">
//                   <div className="col-md-5">
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="userID"
//                       value={newUser.userID}
//                       onChange={(e) =>
//                         setNewUser({ ...newUser, userID: e.target.value })
//                       }
//                       placeholder="Enter customer ID"
//                     />
//                   </div>
//                   <div className="col-md-2">
//                     <button
//                       className="btn btn-danger"
//                       onClick={handleAddUser}
//                       disabled={
//                         !newUser.userID || !newUser.preapprovedLimitValue
//                       }
//                     >
//                       Add User
//                     </button>
//                   </div>
//                 </div>

//                 {errorMessage && (
//                   <div className="alert alert-danger mt-3">{errorMessage}</div>
//                 )}
//               </div>
//             )}

//             {/* Excel Upload Section */}
//             {inputMethod === "excel" && (
//               <div className="p-1 mb-1 d-flex justify-content-center">
//                 <input
//                   type="file"
//                   accept=".xlsx, .xls"
//                   onChange={handleFileUpload}
//                   className="form-control mb-3"
//                 />
//               </div>
//             )}

//             {/* Added Customers Table */}
//             {users.length > 0 && (
//               <div className="p-1">
//                 <h4 className="fw-semibold mb-1">Added Customers</h4>
//                 <div style={{ maxHeight: "28vh", overflowY: "auto", scrollbarColor: "#ee373b #ffffff" }}>
//                   <table className="table table-hover align-middle">
//                     <thead className="table-light sticky-top">
//                       <tr>
//                         <th>Customer Ref ID</th>
//                         <th>Preapproved Loan Value</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {users.map((user, index) => (
//                         <tr key={index}>
//                           <td>{user.userID}</td>
//                           <td>{user.preapprovedLimitValue}</td>
//                           <td>
//                             <button
//                               className="btn btn-sm btn-outline-danger"
//                               onClick={() => {
//                                 const updatedUsers = [...users];
//                                 updatedUsers.splice(index, 1);
//                                 setUsers(updatedUsers);
//                               }}
//                             >
//                               Remove
//                             </button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         {currentStep === 5 && !isComplete && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Review & Create Event
//             </h2>
//             <div className="space-y-4">
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Event Type:{" "}
//                 {EVENT_TYPES.find((t) => t.value === eventType)?.label ||
//                   eventType}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Date: {formData.selectedDate?.toLocaleDateString()}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Selected Time Slots:{" "}
//                 {formData.selectedTimeSlots
//                   ?.filter((slot) => slot.selected)
//                   .map((slot) => slot.time)
//                   .join(", ")}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Approval Limit:{" "}
//                 {
//                   APPROVAL_RANGES.find(
//                     (range) => range.value === formData.approvalLimit
//                   )?.label
//                 }
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Location: {location}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Duration:{" "}
//                 {durationOptions.length > 0
//                   ? durationOptions.find(
//                       (duration) => duration.value === formData.duration
//                     )?.label
//                   : `${formData.duration} Mins`}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Selected People: {users.length} customers
//               </p>
//             </div>
//           </div>
//         )}

//         {isComplete && (
//           <div className="text-center mt-5">
//             <div
//               className="d-inline-flex justify-content-center align-items-center bg-white mb-4"
//               style={{
//                 width: "4rem",
//                 height: "4rem",
//                 border: "1px solid #ee373b",
//                 borderRadius: "4rem",
//               }}
//             >
//               <Check className="w-8 h-8 text-danger bg-white" />
//             </div>
//             <h2 className="h2 mb-2">Event Created Successfully!</h2>
//             <p className="text-muted">
//               Your event has been scheduled and invitations will be sent to the
//               selected participants.
//             </p>
//             {link.length > 0 ? (
//               <TextDisplayCopy link={link} />
//             ) : (
//               <button
//                 onClick={() => navigate("/lenderEvent")}
//                 className="btn btn-danger mt-3"
//               >
//                 Manage Events
//               </button>
//             )}
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="min-vh-100 align-items-center p-4">
//       <div
//         className="w-100 max-w-4xl bg-white overflow-hidden position-relative"
//         style={{
//           minHeight: "75vh",
//           maxHeight: "75vh",
//           borderRadius: "20px",
//           border: "2px solid red",
//         }}
//       >
//         <div style={{ backgroundColor: "#ee373b", padding: "5px" }}>
//           <h2 style={{ color: "white", fontWeight: "bold" }}>
//             Create Event for Private Lender
//           </h2>
//         </div>
//         <div className="h-100 px-3 d-flex flex-column position-relative">
//           {renderStep()}
//           {!isComplete && (
//             <div
//               className="d-flex gap-2 justify-content-end p-3 mt-auto position-fixed"
//               style={{
//                 backgroundColor: "rgba(0,0,0,0)",
//                 top: "calc(50vh + 170px)",
//                 right: "calc(2vw + 15px)",
//               }}
//             >
//               {currentStep > 1 && (
//                 <button onClick={handleBack} className="btn btn-outline-danger">
//                   Back
//                 </button>
//               )}
//               <button
//                 onClick={handleNext}
//                 className="btn btn-danger"
//                 disabled={!isStepValid || (currentStep === 5 && isCreating)}
//               >
//                 {currentStep === 5
//                   ? isCreating
//                     ? "Creating..."
//                     : "Create Event"
//                   : "Next"}
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PrivateLenderEventCreation;

//==========================================below is open event implementation==========================

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { Check } from "lucide-react";
// import { format, parseISO } from "date-fns";
// import * as XLSX from "xlsx";

// const APPROVAL_RANGES = [
//   { id: "1", label: "5 Lakhs", value: "500000" },
//   { id: "2", label: "7 Lakhs", value: "700000" },
//   { id: "3", label: "10 Lakhs", value: "1000000" },
// ];

// const EVENT_TYPES = [
//   { id: "1", label: "Demo Cars", value: "0" },
//   { id: "2", label: "Pre-Owned Cars", value: "1" },
// ];

// function TextDisplayCopy({ link }) {
//   const [text, setText] = useState(link);
//   const [isCopied, setIsCopied] = useState(false);

//   const handleCopy = () => {
//     navigator.clipboard.writeText(text).then(() => {
//       setIsCopied(true);
//       setTimeout(() => setIsCopied(false), 1500);
//     });
//   };

//   const styles = {
//     container: {
//       maxWidth: "800px",
//       margin: "0 auto",
//       display: "flex",
//       boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
//     },
//     textDisplay: {
//       flexGrow: 1,
//       padding: "12px",
//       backgroundColor: "white",
//       border: "1px solid #ccc",
//       borderRight: "none",
//       whiteSpace: "nowrap",
//       overflow: "hidden",
//       textOverflow: "ellipsis",
//       color: "#333",
//     },
//     copyButton: {
//       width: "48px",
//       padding: "12px",
//       backgroundColor: isCopied ? "#22c55e" : "#ef4444",
//       color: "white",
//       border: "none",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "background-color 0.3s ease",
//     },
//     icon: {
//       width: "20px",
//       height: "20px",
//       animation: isCopied ? "pulse 1.5s ease" : "none",
//     },
//   };

//   return (
//     <>
//       <style>{`
//         @keyframes pulse {
//           0% { transform: scale(1); }
//           25% { transform: scale(1.2); }
//           50% { transform: scale(1); }
//           75% { transform: scale(1.1); }
//           100% { transform: scale(1); }
//         }
//       `}</style>
//       <div style={styles.container}>
//         <div style={styles.textDisplay}>{text}</div>
//         <button
//           onClick={handleCopy}
//           style={styles.copyButton}
//           aria-label="Copy text"
//         >
//           {isCopied ? (
//             <svg
//               style={styles.icon}
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M5 13l4 4L19 7"
//               ></path>
//             </svg>
//           ) : (
//             <svg
//               style={styles.icon}
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
//               ></path>
//             </svg>
//           )}
//         </button>
//       </div>
//     </>
//   );
// }

// const WeeklyCalendar = ({ selectedDate, onDateSelect, availableSlots }) => {
//   const weekDays = Object.keys(availableSlots)
//     .sort((a, b) => new Date(a) - new Date(b))
//     .map((date) => parseISO(date));

//   return (
//     <div
//       className="d-flex gap-2"
//       style={{ overflowX: "auto", maxWidth: "100%" }}
//     >
//       {weekDays.map((date) => {
//         const dateKey = format(date, "yyyy-MM-dd");
//         const hasSlots = availableSlots[dateKey]?.length > 0;
//         const carCount = availableSlots[dateKey]?.[0]?.carCountBelow1176 || 0;
//         return (
//           <button
//             key={dateKey}
//             onClick={() => {
//               console.log(`Selected date: ${dateKey}`);
//               hasSlots && onDateSelect(date);
//             }}
//             disabled={!hasSlots}
//             className={`p-4 text-black ${
//               selectedDate?.toDateString() === date.toDateString()
//                 ? "bg-danger text-white"
//                 : "bg-white hover:bg-light"
//             }`}
//             style={
//               hasSlots
//                 ? { border: "2px solid #ee373b", borderRadius: "10px" }
//                 : { cursor: "not-allowed", opacity: 0.5, borderRadius: "10px" }
//             }
//           >
//             <div className="text-sm">{format(date, "EEE")}</div>
//             <div className="text-lg font-semibold">{format(date, "d")}</div>
//             <div className="text-sm">Car Count: {carCount}</div>
//           </button>
//         );
//       })}
//     </div>
//   );
// };

// const TimeSlots = ({ timeSlots, onTimeSlotSelect }) => {
//   return (
//     <div
//       className="d-flex flex-wrap gap-2 mt-6 mx-lg-10"
//       style={{ overflowY: "auto" }}
//     >
//       {timeSlots.map((slot, index) => (
//         <button
//           key={slot.time}
//           onClick={() => {
//             console.log(`Selected time slot: ${slot.time}`);
//             onTimeSlotSelect(index);
//           }}
//           className={`p-3 transition text-black ${
//             slot.selected ? "bg-danger text-white" : "bg-white hover:bg-light"
//           }`}
//           style={{ border: "2px solid #ee373b" }}
//         >
//           {slot.time}
//         </button>
//       ))}
//     </div>
//   );
// };

// const PrivateLenderEventCreation = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     selectedDate: null,
//     selectedTimeSlots: null,
//     approvalLimit: "",
//     duration: "",
//   });
//   const [isComplete, setIsComplete] = useState(false);
//   const [availableSlots, setAvailableSlots] = useState({});
//   const [users, setUsers] = useState([]);
//   const [communityNo, setCommunityNo] = useState(null);
//   const [eventTitle, setEventTitle] = useState("");
//   const [location, setLocation] = useState("");
//   const [carCount, setCarCount] = useState(0);
//   const [link, setLink] = useState("");
//   const [isStepValid, setIsStepValid] = useState(false);
//   const [durationOptions, setDurationOptions] = useState([]);
//   const [isCreating, setIsCreating] = useState(false);
//   const [newUser, setNewUser] = useState({
//     userID: "",
//     preapprovedLimitValue: "",
//   });
//   const [errorMessage, setErrorMessage] = useState("");
//   const [vehicleType, setVehicleType] = useState("");
//   const [eventType, setEventType] = useState(""); // New state for event type
//   const [inputMethod, setInputMethod] = useState("manual");
//   const navigate = useNavigate();

//   useEffect(() => {
//     console.log("Fetching community number and lender info");
//     const communityNumber = parseInt(Cookies.get("adminCommunityNO"), 10);
//     setCommunityNo(communityNumber);
//     const lenderInfoRaw = Cookies.get("adminLenderInfo") || "";
//     const [firstName = "", lastName = ""] = lenderInfoRaw.split("_");
//     const lenderInfo = `${firstName} ${lastName}`.trim();
//     const loc = Cookies.get("adminLocation") || "";
//     setLocation(loc);
//     const eventTitles = `${lenderInfo} ${loc}`.trim();
//     setEventTitle(eventTitles);
//     fetch(
//       `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/showAvailableSlotsForNextWeek?location=${loc}`,
//       {
//         credentials: "include",
//         headers: {
//           "X-Full-URL": window.location.href,
//         },
//       }
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Available slots fetched:", data);
//         setAvailableSlots(data);
//       })
//       .catch((error) => {
//         console.error("Error fetching available slots:", error);
//       });
//   }, []);

//   useEffect(() => {
//     if (formData.selectedTimeSlots) {
//       const selectedSlot = formData.selectedTimeSlots.find(
//         (slot) => slot.selected
//       );
//       if (selectedSlot) {
//         console.log(
//           `Fetching duration options for slot ID: ${selectedSlot.id}`
//         );
//         fetch(
//           `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/duration-options?slotId=${selectedSlot.id}`,
//           {
//             credentials: "include",
//             headers: {
//               "X-Full-URL": window.location.href,
//             },
//           }
//         )
//           .then((response) => {
//             if (!response.ok) {
//               throw new Error("Network response was not ok");
//             }
//             return response.json();
//           })
//           .then((data) => {
//             console.log("Duration options fetched:", data);
//             const formattedOptions = data.map((option, index) => {
//               const minutes = parseInt(option.replace(/\D/g, ""));
//               return {
//                 id: (index + 1).toString(),
//                 label: option,
//                 value: minutes.toString(),
//               };
//             });
//             setDurationOptions(formattedOptions);
//           })
//           .catch((error) => {
//             console.error("Error fetching duration options:", error);
//             const fallbackOptions = [
//               { id: "1", label: "5 Mins", value: "5" },
//               { id: "2", label: "10 Mins", value: "10" },
//               { id: "3", label: "15 Mins", value: "15" },
//               { id: "4", label: "30 Mins", value: "30" },
//               { id: "5", label: "45 Mins", value: "45" },
//               { id: "6", label: "1 Hour", value: "60" },
//             ];
//             setDurationOptions(fallbackOptions);
//           });
//       }
//     }
//   }, [formData.selectedTimeSlots]);

//   useEffect(() => {
//     console.log(`Validating step ${currentStep}`);
//     if (currentStep === 1) {
//       const isValid = !!vehicleType;
//       setIsStepValid(isValid);
//     } else if (currentStep === 2) {
//       const isValid = !!eventType;
//       setIsStepValid(isValid);
//     } else if (currentStep === 3) {
//       const isValid =
//         formData.selectedDate &&
//         formData.selectedTimeSlots?.some((slot) => slot.selected);
//       setIsStepValid(isValid);
//     } else if (currentStep === 4) {
//       const isValid = formData.duration; // For open events, only duration is needed
//       setIsStepValid(isValid);
//     } else if (currentStep === 5) {
//       const isValid = users.length > 0;
//       setIsStepValid(isValid);
//     } else if (currentStep === 6) {
//       setIsStepValid(true);
//     }
//   }, [formData, users, currentStep, vehicleType, eventType]);

//   const handleDateSelect = (date) => {
//     const dateKey = format(date, "yyyy-MM-dd");
//     const slotsForDate = availableSlots[dateKey] || [];
//     const formattedTimeSlots = slotsForDate.map((slot) => ({
//       time: slot.availebleSlot,
//       selected: false,
//       id: slot.slotId,
//     }));
//     setFormData((prev) => ({
//       ...prev,
//       selectedDate: date,
//       selectedTimeSlots: formattedTimeSlots,
//     }));
//     const carCount = slotsForDate[0]?.carCountBelow1176 || 0;
//     setCarCount(carCount);
//   };

//   const handleTimeSlotSelect = (index) => {
//     const updatedSlots = formData.selectedTimeSlots.map((slot, i) => ({
//       ...slot,
//       selected: i === index,
//     }));
//     setFormData((prev) => ({
//       ...prev,
//       selectedTimeSlots: updatedSlots,
//     }));
//     setFormData((prev) => ({
//       ...prev,
//       duration: "",
//     }));
//     setCurrentStep(4);
//   };

//   const handleApprovalLimitChange = (e) => {
//     const selectedLimit = e.target.value;
//     console.log(`Selected approval limit: ${selectedLimit}`);
//     setFormData((prev) => ({ ...prev, approvalLimit: selectedLimit }));
//     setNewUser((prev) => ({
//       ...prev,
//       preapprovedLimitValue: selectedLimit,
//     }));
//   };

//   const handleDurationChange = (e) => {
//     console.log(`Selected duration: ${e.target.value}`);
//     setFormData((prev) => ({ ...prev, duration: e.target.value }));
//   };

//   const handleAddUser = () => {
//     if (!newUser.userID || !newUser.preapprovedLimitValue) {
//       return;
//     }
//     const userExists = users.some((user) => user.userID === newUser.userID);
//     if (userExists) {
//       setErrorMessage("User with this ID already exists");
//       return;
//     }
//     setErrorMessage("");
//     setUsers([
//       ...users,
//       {
//         name: "private buyer",
//         userID: newUser.userID,
//         preapprovedLimitValue: Number(newUser.preapprovedLimitValue),
//       },
//     ]);
//     setNewUser({
//       userID: "",
//       preapprovedLimitValue: formData.approvalLimit || "",
//     });
//   };

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       console.log(`File uploaded: ${file.name}`);
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: "array" });
//         const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//         // Get raw data with headers
//         const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
//         if (rawData.length === 0) {
//           console.warn("Empty Excel file.");
//           return;
//         }
//         // Normalize headers
//         const headers = rawData[0].map((h) =>
//           typeof h === "string" ? h.toLowerCase().trim() : ""
//         );
//         // Convert raw rows to objects using normalized headers
//         const jsonData = rawData.slice(1).map((row) => {
//           const obj = {};
//           headers.forEach((key, index) => {
//             obj[key] = row[index];
//           });
//           return obj;
//         });
//         // Filter and process rows with valid numeric data
//         const processedUsers = jsonData
//           .filter((row) => {
//             const value = row["preapproved loan value"];
//             const userID = row["customer ref id"];
//             return (
//               value !== undefined &&
//               value !== null &&
//               value !== "" &&
//               !isNaN(Number(value)) &&
//               userID !== undefined &&
//               userID !== null &&
//               userID !== ""
//             );
//           })
//           .map((row) => ({
//             name: "private buyer",
//             preapprovedLimitValue: Number(row["preapproved loan value"]),
//             userID: row["customer ref id"],
//           }));
//         console.log("Processed users from file:", processedUsers);
//         setUsers(processedUsers);
//       };
//       reader.readAsArrayBuffer(file);
//     }
//   };

//   const handleNext = () => {
//     console.log(`Moving to next step from step ${currentStep}`);
//     if (currentStep < 6) {
//       setCurrentStep((prev) => prev + 1);
//     } else {
//       handleCreateEvent();
//     }
//   };

//   const handleBack = () => {
//     console.log(`Moving back to step ${currentStep - 1}`);
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   const handleCreateEvent = () => {
//     console.log("Creating event...");
//     setIsCreating(true);
//     const selectedTimeSlot = formData.selectedTimeSlots.find(
//       (slot) => slot.selected
//     );
//     const startDate = new Date(formData.selectedDate);
//     const [hours, minutes] = selectedTimeSlot.time.split(":").map(Number);
//     startDate.setHours(hours, minutes, 0, 0);
//     const endDate = new Date(startDate);
//     endDate.setMinutes(endDate.getMinutes() + parseInt(formData.duration, 10));
//     const formatDateTime = (date) => {
//       const pad = (n) => n.toString().padStart(2, "0");
//       const year = date.getFullYear();
//       const month = pad(date.getMonth() + 1);
//       const day = pad(date.getDate());
//       const hours = pad(date.getHours());
//       const minutes = pad(date.getMinutes());
//       const seconds = pad(date.getSeconds());
//       return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//     };
//     // const eventData = {
//     //   eventTitle: eventTitle + (vehicleType == 0 ? " - **DEMO CARS**" : ""),
//     //   location: location,
//     //   startDateAndTime: formatDateTime(startDate),
//     //   endDateAndTime: formatDateTime(endDate),
//     //   userApprovedLimit: formData.approvalLimit,
//     //   communityNo: communityNo,
//     //   auctionSlotId: selectedTimeSlot.id,
//     //   duration: formData.duration,
//     //   eventType: vehicleType,
//     // };
//     const eventData = {
//       eventTitle: eventTitle + (vehicleType == 0 ? " - **DEMO CARS**" : ""),
//       location: location,
//       startDateAndTime: formatDateTime(startDate),
//       endDateAndTime: formatDateTime(endDate),
//       userApprovedLimit: formData.approvalLimit,
//       communityNo: communityNo,
//       auctionSlotId: selectedTimeSlot.id,
//       duration: formData.duration,
//       eventType: vehicleType,
//       isOpenEvent: eventType === "open" // Add this line
//     };
//     console.log("Event data to be sent:", eventData);
//     const formDataToSend = new FormData();
//     formDataToSend.append("communityNo", communityNo);
//     formDataToSend.append("users", JSON.stringify(users));
//     formDataToSend.append("eventDetails", JSON.stringify(eventData));
//     formDataToSend.append("vehicleType", Number(vehicleType));
//     formDataToSend.append("isOpenEvent", eventType === "open");
//     fetch(
//       `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/privateLender/createEventWithUsers`,
//       {
//         method: "POST",
//         body: formDataToSend,
//         credentials: "include",
//         headers: {
//           "X-Created-By": "PRIVATE LENDER",
//         },
//       }
//     )
//       .then((response) => {
//         console.log("Response status:", response.status);
//         return response.json();
//       })
//       .then((data) => {
//         console.log("Event creation response:", data);
//         if (data.message.includes("Event created successfully")) {
//           if (data.link) {
//             setLink(data.link);
//           }
//           setIsComplete(true);
//         } else {
//           console.error("Error creating event:", data);
//         }
//       })
//       .catch((error) => {
//         console.error("Error creating event:", error);
//       })
//       .finally(() => {
//         setIsCreating(false);
//       });
//   };

//   const renderStep = () => {
//     return (
//       <div>
//         {currentStep === 1 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Select Vehicle Type
//             </h2>
//             <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
//               <div className="mb-3">
//                 <div className="d-flex justify-content-center gap-5 mt-5">
//                   {EVENT_TYPES.map((type) => (
//                     <button
//                       className="event-type-button"
//                       key={type.id}
//                       value={type.value}
//                       onClick={(e) => {
//                         setVehicleType(type.value);
//                         setCurrentStep(2);
//                       }}
//                     >
//                       {type.label}
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//         {currentStep === 2 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Select Event Type
//             </h2>
//             <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
//               <div className="mb-3">
//                 <div className="d-flex justify-content-center gap-5 mt-5">
//                   <button
//                     className="event-type-button"
//                     onClick={() => {
//                       setEventType("pre-approved");
//                       setCurrentStep(3);
//                     }}
//                   >
//                     Pre-Approved Event
//                   </button>
//                   <button
//                     className="event-type-button"
//                     onClick={() => {
//                       setEventType("open");
//                       setFormData((prev) => ({ ...prev, approvalLimit: "2000000" }));
//                       setCurrentStep(3);
//                     }}
//                   >
//                     Open Event
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//         {currentStep === 3 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Select Date & Time
//             </h2>
//             <div className="d-flex flex-column gap-5 justify-content-center align-items-center">
//               <WeeklyCalendar
//                 selectedDate={formData.selectedDate}
//                 onDateSelect={handleDateSelect}
//                 availableSlots={availableSlots}
//               />
//               {formData.selectedDate && (
//                 <TimeSlots
//                   timeSlots={formData.selectedTimeSlots}
//                   onTimeSlotSelect={handleTimeSlotSelect}
//                 />
//               )}
//               {carCount > 0 && <div className="mt-4"></div>}
//             </div>
//           </div>
//         )}
//         {currentStep === 4 && eventType === "pre-approved" && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Set Approval Limit & Duration
//             </h2>
//             <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
//               <div className="mb-3">
//                 <label htmlFor="approvalLimit" className="form-label">
//                   Approval Limit
//                 </label>
//                 <select
//                   id="approvalLimit"
//                   value={formData.approvalLimit}
//                   style={{ maxWidth: "300px" }}
//                   onChange={handleApprovalLimitChange}
//                   className="form-select"
//                 >
//                   <option value="">Select Pre-Approval Limit</option>
//                   {APPROVAL_RANGES.map((range) => (
//                     <option key={range.id} value={range.value}>
//                       {range.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="mb-3">
//                 <label htmlFor="duration" className="form-label">
//                   Duration of Event
//                 </label>
//                 <select
//                   id="duration"
//                   value={formData.duration}
//                   onChange={handleDurationChange}
//                   style={{
//                     maxWidth: "300px",
//                     maxHeight: "100px",
//                     overflowY: "auto",
//                     scrollbarColor: "#ee373b #ffffff",
//                   }}
//                   className="form-select"
//                 >
//                   <option value="">Select Duration</option>
//                   {durationOptions.length > 0 ? (
//                     durationOptions.map((duration) => (
//                       <option key={duration.id} value={duration.value}>
//                         {duration.label}
//                       </option>
//                     ))
//                   ) : (
//                     <>
//                       <option value="5">5 Mins</option>
//                       <option value="10">10 Mins</option>
//                       <option value="15">15 Mins</option>
//                       <option value="30">30 Mins</option>
//                       <option value="45">45 Mins</option>
//                       <option value="60">1 Hour</option>
//                       <option value="120">2 Hours</option>
//                       <option value="180">3 Hours</option>
//                       <option value="240">4 Hours</option>
//                     </>
//                   )}
//                 </select>
//               </div>
//             </div>
//           </div>
//         )}
//         {currentStep === 4 && eventType === "open" && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Set Duration
//             </h2>
//             <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
//               <div className="mb-3">
//                 <label htmlFor="duration" className="form-label">
//                   Duration of Event
//                 </label>
//                 <select
//                   id="duration"
//                   value={formData.duration}
//                   onChange={handleDurationChange}
//                   style={{
//                     maxWidth: "300px",
//                     maxHeight: "100px",
//                     overflowY: "auto",
//                     scrollbarColor: "#ee373b #ffffff",
//                   }}
//                   className="form-select"
//                 >
//                   <option value="">Select Duration</option>
//                   {durationOptions.length > 0 ? (
//                     durationOptions.map((duration) => (
//                       <option key={duration.id} value={duration.value}>
//                         {duration.label}
//                       </option>
//                     ))
//                   ) : (
//                     <>
//                       <option value="5">5 Mins</option>
//                       <option value="10">10 Mins</option>
//                       <option value="15">15 Mins</option>
//                       <option value="30">30 Mins</option>
//                       <option value="45">45 Mins</option>
//                       <option value="60">1 Hour</option>
//                       <option value="120">2 Hours</option>
//                       <option value="180">3 Hours</option>
//                       <option value="240">4 Hours</option>
//                     </>
//                   )}
//                 </select>
//               </div>
//             </div>
//           </div>
//         )}
//         {currentStep === 5 && (
//           <div className="container py-3">
//             <div className="d-flex justify-content-between align-items-center mb-4">
//               <span className="d-none d-lg-block" style={{width: "100px"}}></span>

//               <h2 className="mb-0 d-none d-lg-block" style={{ color: "#ee373b" }}>
//                 Add Customer Data
//               </h2>
//               {/* Mobile / small to medium screens (below lg) */}
//               <h5 className="mb-0 d-block d-lg-none" style={{ color: "#ee373b" }}>
//                 Add Customer Data
//               </h5>
//               {/* Single Toggle Button */}
//               <button
//                 className="btn btn-danger"
//                 style={{width: "100px"}}
//                 onClick={() =>
//                   {
//                     setInputMethod(inputMethod === "manual" ? "excel" : "manual")
//                     setUsers([]);
//                   }
//                 }
//               >
//                 {inputMethod === "manual"
//                   ? "Excel Upload"
//                   : "Manual Input"}
//               </button>
//             </div>
//             {/* Manual Input Section */}
//             {inputMethod === "manual" && (
//               <div className="p-2 mb-1">
//                 <div className="d-flex align-items-end d-flex justify-content-center">
//                   <div className="col-md-5">
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="userID"
//                       value={newUser.userID}
//                       onChange={(e) =>
//                         setNewUser({ ...newUser, userID: e.target.value })
//                       }
//                       placeholder="Enter customer ID"
//                     />
//                   </div>
//                   <div className="col-md-2">
//                     <button
//                       className="btn btn-danger"
//                       onClick={handleAddUser}
//                       disabled={
//                         !newUser.userID || !newUser.preapprovedLimitValue
//                       }
//                     >
//                       Add User
//                     </button>
//                   </div>
//                 </div>
//                 {errorMessage && (
//                   <div className="alert alert-danger mt-3">{errorMessage}</div>
//                 )}
//               </div>
//             )}
//             {/* Excel Upload Section */}
//             {inputMethod === "excel" && (
//               <div className="p-1 mb-1 d-flex justify-content-center">
//                 <input
//                   type="file"
//                   accept=".xlsx, .xls"
//                   onChange={handleFileUpload}
//                   className="form-control mb-3"
//                 />
//               </div>
//             )}
//             {/* Added Customers Table */}
//             {users.length > 0 && (
//               <div className="p-1">
//                 <h4 className="fw-semibold mb-1">Added Customers</h4>
//                 <div style={{ maxHeight: "28vh", overflowY: "auto", scrollbarColor: "#ee373b #ffffff" }}>
//                   <table className="table table-hover align-middle">
//                     <thead className="table-light sticky-top">
//                       <tr>
//                         <th>Customer Ref ID</th>
//                         <th>Preapproved Loan Value</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {users.map((user, index) => (
//                         <tr key={index}>
//                           <td>{user.userID}</td>
//                           <td>{user.preapprovedLimitValue}</td>
//                           <td>
//                             <button
//                               className="btn btn-sm btn-outline-danger"
//                               onClick={() => {
//                                 const updatedUsers = [...users];
//                                 updatedUsers.splice(index, 1);
//                                 setUsers(updatedUsers);
//                               }}
//                             >
//                               Remove
//                             </button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
//         {currentStep === 6 && !isComplete && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Review & Create Event
//             </h2>
//             <div className="space-y-4">
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Event Type:{" "}
//                 {EVENT_TYPES.find((t) => t.value === vehicleType)?.label ||
//                   vehicleType}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Date: {formData.selectedDate?.toLocaleDateString()}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Selected Time Slots:{" "}
//                 {formData.selectedTimeSlots
//                   ?.filter((slot) => slot.selected)
//                   .map((slot) => slot.time)
//                   .join(", ")}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Approval Limit:{" "}
//                 {eventType === "open" ? "2000000" :
//                   APPROVAL_RANGES.find(
//                     (range) => range.value === formData.approvalLimit
//                   )?.label}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Location: {location}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Duration:{" "}
//                 {durationOptions.length > 0
//                   ? durationOptions.find(
//                       (duration) => duration.value === formData.duration
//                     )?.label
//                   : `${formData.duration} Mins`}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Selected People: {users.length} customers
//               </p>
//             </div>
//           </div>
//         )}
//         {isComplete && (
//           <div className="text-center mt-5">
//             <div
//               className="d-inline-flex justify-content-center align-items-center bg-white mb-4"
//               style={{
//                 width: "4rem",
//                 height: "4rem",
//                 border: "1px solid #ee373b",
//                 borderRadius: "4rem",
//               }}
//             >
//               <Check className="w-8 h-8 text-danger bg-white" />
//             </div>
//             <h2 className="h2 mb-2">Event Created Successfully!</h2>
//             <p className="text-muted">
//               Your event has been scheduled and invitations will be sent to the
//               selected participants.
//             </p>
//             {link.length > 0 ? (
//               <TextDisplayCopy link={link} />
//             ) : (
//               <button
//                 onClick={() => navigate("/lenderEvent")}
//                 className="btn btn-danger mt-3"
//               >
//                 Manage Events
//               </button>
//             )}
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="min-vh-100 align-items-center p-4">
//       <div
//         className="w-100 max-w-4xl bg-white overflow-hidden position-relative"
//         style={{
//           minHeight: "75vh",
//           maxHeight: "75vh",
//           borderRadius: "20px",
//           border: "2px solid red",
//         }}
//       >
//         <div style={{ backgroundColor: "#ee373b", padding: "5px" }}>
//           <h2 style={{ color: "white", fontWeight: "bold" }}>
//             Create Event for Private Lender
//           </h2>
//         </div>
//         <div className="h-100 px-3 d-flex flex-column position-relative">
//           {renderStep()}
//           {!isComplete && (
//             <div
//               className="d-flex gap-2 justify-content-end p-3 mt-auto position-fixed"
//               style={{
//                 backgroundColor: "rgba(0,0,0,0)",
//                 top: "calc(50vh + 170px)",
//                 right: "calc(2vw + 15px)",
//               }}
//             >
//               {currentStep > 1 && (
//                 <button onClick={handleBack} className="btn btn-outline-danger">
//                   Back
//                 </button>
//               )}
//               <button
//                 onClick={handleNext}
//                 className="btn btn-danger"
//                 disabled={!isStepValid || (currentStep === 6 && isCreating)}
//               >
//                 {currentStep === 6
//                   ? isCreating
//                     ? "Creating..."
//                     : "Create Event"
//                   : "Next"}
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PrivateLenderEventCreation;


//---------------------------------------------------------------------------------------

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Check } from "lucide-react";
import { format, parseISO } from "date-fns";
import * as XLSX from "xlsx";
import { encryptObject, encryptValue } from "../utils/cryptoUtil";

const APPROVAL_RANGES = [
  { id: "1", label: "5 Lakhs", value: "500000" },
  { id: "2", label: "7 Lakhs", value: "700000" },
  { id: "3", label: "10 Lakhs", value: "1000000" },
];

const EVENT_TYPES = [
  { id: "1", label: "Demo Cars", value: "0" },
  { id: "2", label: "Pre-Owned Cars", value: "1" },
];

function TextDisplayCopy({ link }) {
  const [text, setText] = useState(link);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    });
  };

  const styles = {
    container: {
      maxWidth: "800px",
      margin: "0 auto",
      display: "flex",
      boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
    },
    textDisplay: {
      flexGrow: 1,
      padding: "12px",
      backgroundColor: "white",
      border: "1px solid #ccc",
      borderRight: "none",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: "#333",
    },
    copyButton: {
      width: "48px",
      padding: "12px",
      backgroundColor: isCopied ? "#22c55e" : "#ef4444",
      color: "white",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background-color 0.3s ease",
    },
    icon: {
      width: "20px",
      height: "20px",
      animation: isCopied ? "pulse 1.5s ease" : "none",
    },
  };

  return (
    <>
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          25% { transform: scale(1.2); }
          50% { transform: scale(1); }
          75% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      `}</style>
      <div style={styles.container}>
        <div style={styles.textDisplay}>{text}</div>
        <button
          onClick={handleCopy}
          style={styles.copyButton}
          aria-label="Copy text"
        >
          {isCopied ? (
            <svg
              style={styles.icon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          ) : (
            <svg
              style={styles.icon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </>
  );
}

const WeeklyCalendar = ({ selectedDate, onDateSelect, availableSlots }) => {
  const weekDays = Object.keys(availableSlots)
    .sort((a, b) => new Date(a) - new Date(b))
    .map((date) => parseISO(date));

  return (
    <div
      className="d-flex gap-2"
      style={{ overflowX: "auto", maxWidth: "100%" }}
    >
      {weekDays.map((date) => {
        const dateKey = format(date, "yyyy-MM-dd");
        const hasSlots = availableSlots[dateKey]?.length > 0;
        const carCount = availableSlots[dateKey]?.[0]?.carCountBelow1176 || 0;
        return (
          <button
            key={dateKey}
            onClick={() => {
              console.log(`Selected date: ${dateKey}`);
              hasSlots && onDateSelect(date);
            }}
            disabled={!hasSlots}
            className={`p-4 text-black ${
              selectedDate?.toDateString() === date.toDateString()
                ? "bg-danger text-white"
                : "bg-white hover:bg-light"
            }`}
            style={
              hasSlots
                ? { border: "2px solid #ee373b", borderRadius: "10px" }
                : { cursor: "not-allowed", opacity: 0.5, borderRadius: "10px" }
            }
          >
            <div className="text-sm">{format(date, "EEE")}</div>
            <div className="text-lg font-semibold">{format(date, "d")}</div>
            <div className="text-sm">Car Count: {carCount}</div>
          </button>
        );
      })}
    </div>
  );
};

const TimeSlots = ({ timeSlots, onTimeSlotSelect }) => {
  return (
    <div
      className="d-flex flex-wrap gap-2 mt-6 mx-lg-10"
      style={{ overflowY: "auto" }}
    >
      {timeSlots.map((slot, index) => (
        <button
          key={slot.time}
          onClick={() => {
            console.log(`Selected time slot: ${slot.time}`);
            onTimeSlotSelect(index);
          }}
          className={`p-3 transition text-black ${
            slot.selected ? "bg-danger text-white" : "bg-white hover:bg-light"
          }`}
          style={{ border: "2px solid #ee373b" }}
        >
          {slot.time}
        </button>
      ))}
    </div>
  );
};

const PrivateLenderEventCreation = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    selectedDate: null,
    selectedTimeSlots: null,
    approvalLimit: "",
    duration: "",
  });
  const [isComplete, setIsComplete] = useState(false);
  const [availableSlots, setAvailableSlots] = useState({});
  const [users, setUsers] = useState([]);
  const [communityNo, setCommunityNo] = useState(null);
  const [eventTitle, setEventTitle] = useState("");
  const [location, setLocation] = useState("");
  const [carCount, setCarCount] = useState(0);
  const [link, setLink] = useState("");
  const [isStepValid, setIsStepValid] = useState(false);
  const [durationOptions, setDurationOptions] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [newUser, setNewUser] = useState({
    userID: "",
    preapprovedLimitValue: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [eventType, setEventType] = useState(""); // New state for event type
  const [inputMethod, setInputMethod] = useState("manual");
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Fetching community number and lender info");
    const communityNumber = parseInt(Cookies.get("adminCommunityNO"), 10);
    setCommunityNo(communityNumber);
    const lenderInfoRaw = Cookies.get("adminLenderInfo") || "";
    const [firstName = "", lastName = ""] = lenderInfoRaw.split("_");
    const lenderInfo = `${firstName} ${lastName}`.trim();
    const loc = Cookies.get("adminLocation") || "";
    setLocation(loc);
    const eventTitles = `${lenderInfo} ${loc}`.trim();
    setEventTitle(eventTitles);
    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/showAvailableSlotsForNextWeek?location=${encryptValue(loc)}`,
      {
        credentials: "include",
        headers: {
          "X-Full-URL": window.location.href,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("Available slots fetched:", data);
        setAvailableSlots(data);
      })
      .catch((error) => {
        console.error("Error fetching available slots:", error);
      });
  }, []);

  useEffect(() => {
    if (formData.selectedTimeSlots) {
      const selectedSlot = formData.selectedTimeSlots.find(
        (slot) => slot.selected
      );
      if (selectedSlot) {
        console.log(
          `Fetching duration options for slot ID: ${selectedSlot.id}`
        );
        fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/duration-options?slotId=${encryptValue(selectedSlot.id)}`,
          {
            credentials: "include",
            headers: {
              "X-Full-URL": window.location.href,
            },
          }
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            console.log("Duration options fetched:", data);
            const formattedOptions = data.map((option, index) => {
              const minutes = parseInt(option.replace(/\D/g, ""));
              return {
                id: (index + 1).toString(),
                label: option,
                value: minutes.toString(),
              };
            });
            setDurationOptions(formattedOptions);
          })
          .catch((error) => {
            console.error("Error fetching duration options:", error);
            const fallbackOptions = [
              { id: "1", label: "5 Mins", value: "5" },
              { id: "2", label: "10 Mins", value: "10" },
              { id: "3", label: "15 Mins", value: "15" },
              { id: "4", label: "30 Mins", value: "30" },
              { id: "5", label: "45 Mins", value: "45" },
              { id: "6", label: "1 Hour", value: "60" },
            ];
            setDurationOptions(fallbackOptions);
          });
      }
    }
  }, [formData.selectedTimeSlots]);

  useEffect(() => {
    console.log(`Validating step ${currentStep}`);
    if (currentStep === 1) {
      const isValid = !!vehicleType;
      setIsStepValid(isValid);
    } else if (currentStep === 2) {
      const isValid = !!eventType;
      setIsStepValid(isValid);
    } else if (currentStep === 3) {
      const isValid =
        formData.selectedDate &&
        formData.selectedTimeSlots?.some((slot) => slot.selected);
      setIsStepValid(isValid);
    } else if (currentStep === 4) {
      const isValid = formData.approvalLimit && formData.duration;
      setIsStepValid(isValid);
    } else if (currentStep === 5) {
      const isValid = users.length > 0;
      setIsStepValid(isValid);
    } else if (currentStep === 6) {
      setIsStepValid(true);
    }
  }, [formData, users, currentStep, vehicleType, eventType]);

  const handleDateSelect = (date) => {
    const dateKey = format(date, "yyyy-MM-dd");
    const slotsForDate = availableSlots[dateKey] || [];
    const formattedTimeSlots = slotsForDate.map((slot) => ({
      time: slot.availebleSlot,
      selected: false,
      id: slot.slotId,
    }));
    setFormData((prev) => ({
      ...prev,
      selectedDate: date,
      selectedTimeSlots: formattedTimeSlots,
    }));
    const carCount = slotsForDate[0]?.carCountBelow1176 || 0;
    setCarCount(carCount);
  };

  const handleTimeSlotSelect = (index) => {
    const updatedSlots = formData.selectedTimeSlots.map((slot, i) => ({
      ...slot,
      selected: i === index,
    }));
    setFormData((prev) => ({
      ...prev,
      selectedTimeSlots: updatedSlots,
    }));
    setFormData((prev) => ({
      ...prev,
      duration: "",
    }));
    setCurrentStep(4);
  };

  const handleApprovalLimitChange = (e) => {
    const selectedLimit = e.target.value;
    console.log(`Selected approval limit: ${selectedLimit}`);
    setFormData((prev) => ({ ...prev, approvalLimit: selectedLimit }));
    setNewUser((prev) => ({
      ...prev,
      preapprovedLimitValue: selectedLimit,
    }));
  };

  const handleDurationChange = (e) => {
    console.log(`Selected duration: ${e.target.value}`);
    setFormData((prev) => ({ ...prev, duration: e.target.value }));
  };

  const handleAddUser = () => {
    if (!newUser.userID || !newUser.preapprovedLimitValue) {
      return;
    }
    const userExists = users.some((user) => user.userID === newUser.userID);
    if (userExists) {
      setErrorMessage("User with this ID already exists");
      return;
    }
    setErrorMessage("");
    setUsers([
      ...users,
      {
        name: "private buyer",
        userID: newUser.userID,
        preapprovedLimitValue: Number(newUser.preapprovedLimitValue),
      },
    ]);
    setNewUser({
      userID: "",
      preapprovedLimitValue: formData.approvalLimit || "",
    });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log(`File uploaded: ${file.name}`);
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        // Get raw data with headers
        const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        if (rawData.length === 0) {
          console.warn("Empty Excel file.");
          return;
        }
        // Normalize headers
        const headers = rawData[0].map((h) =>
          typeof h === "string" ? h.toLowerCase().trim() : ""
        );
        // Convert raw rows to objects using normalized headers
        const jsonData = rawData.slice(1).map((row) => {
          const obj = {};
          headers.forEach((key, index) => {
            obj[key] = row[index];
          });
          return obj;
        });
        // Filter and process rows with valid numeric data
        const processedUsers = jsonData
          .filter((row) => {
            const value = row["preapproved loan value"];
            const userID = row["customer ref id"];
            return (
              value !== undefined &&
              value !== null &&
              value !== "" &&
              !isNaN(Number(value)) &&
              userID !== undefined &&
              userID !== null &&
              userID !== ""
            );
          })
          .map((row) => ({
            name: "private buyer",
            preapprovedLimitValue: Number(row["preapproved loan value"]),
            userID: row["customer ref id"],
          }));
        console.log("Processed users from file:", processedUsers);
        setUsers(processedUsers);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleNext = () => {
    console.log(`Moving to next step from step ${currentStep}`);
    if (currentStep < 6) {
      setCurrentStep((prev) => prev + 1);
    } else {
      handleCreateEvent();
    }
  };

  const handleBack = () => {
    console.log(`Moving back to step ${currentStep - 1}`);
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleCreateEvent = () => {
    console.log("Creating event...");
    setIsCreating(true);
    const selectedTimeSlot = formData.selectedTimeSlots.find(
      (slot) => slot.selected
    );
    const startDate = new Date(formData.selectedDate);
    const [hours, minutes] = selectedTimeSlot.time.split(":").map(Number);
    startDate.setHours(hours, minutes, 0, 0);
    const endDate = new Date(startDate);
    endDate.setMinutes(endDate.getMinutes() + parseInt(formData.duration, 10));
    const formatDateTime = (date) => {
      const pad = (n) => n.toString().padStart(2, "0");
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const eventData = {
      eventTitle: eventTitle + (vehicleType == 0 ? " - **DEMO CARS**" : ""),
      location: location,
      startDateAndTime: formatDateTime(startDate),
      endDateAndTime: formatDateTime(endDate),
      userApprovedLimit: formData.approvalLimit,
      communityNo: communityNo,
      auctionSlotId: selectedTimeSlot.id,
      duration: formData.duration,
      eventType: vehicleType,
      isPreApproved : eventType == "pre-approved"
    };
    console.log("Event data to be sent:", eventData);
    const formDataToSend = new FormData();
    formDataToSend.append("communityNo", communityNo);
    formDataToSend.append("users", JSON.stringify(users));
    formDataToSend.append("eventDetails", JSON.stringify(eventData));
    formDataToSend.append("vehicleType", Number(vehicleType));
    formDataToSend.append("isPreApproved",eventType == "pre-approved");
    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/privateLender/createEventWithUsers`,
      {
        method: "POST",
        body: formDataToSend,
        credentials: "include",
        headers: {
          "X-Created-By": "PRIVATE LENDER",
        },
      }
    )
      .then((response) => {
        console.log("Response status:", response.status);
        return response.json();
      })
      .then((data) => {
        console.log("Event creation response:", data);
        if (data.message.includes("Event created successfully")) {
          if (data.link) {
            setLink(data.link);
          }
          setIsComplete(true);
        } else {
          console.error("Error creating event:", data);
        }
      })
      .catch((error) => {
        console.error("Error creating event:", error);
      })
      .finally(() => {
        setIsCreating(false);
      });
  };

  const renderStep = () => {
    return (
      <div>
        {currentStep === 1 && (
          <div>
            <h2
              className="h2 mb-6"
              style={{ color: "#ee373b", margin: "15px 0px" }}
            >
              Select Vehicle Type
            </h2>
            <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
              <div className="mb-3">
                <div className="d-flex justify-content-center gap-5 mt-5">
                  {EVENT_TYPES.map((type) => (
                    <button
                      className="event-type-button"
                      key={type.id}
                      value={type.value}
                      onClick={(e) => {
                        setVehicleType(type.value);
                        setCurrentStep(currentStep + 1);
                      }}
                    >
                      {type.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div>
            <h2
              className="h2 mb-6"
              style={{ color: "#ee373b", margin: "15px 0px" }}
            >
              Select Event Type
            </h2>
            <div className="d-flex justify-content-center gap-5 mt-5">
              <button
                className="event-type-button"
                onClick={() => {
                  setEventType("pre-approved");
                  setCurrentStep(3);
                }}
              >
                Pre-Approved Event
              </button>
              <button
                className="event-type-button"
                onClick={() => {
                  setEventType("open");
                  setCurrentStep(3);
                }}
              >
                Open Event
              </button>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div>
            <h2
              className="h2 mb-6"
              style={{ color: "#ee373b", margin: "15px 0px" }}
            >
              Select Date & Time
            </h2>
            <div className="d-flex flex-column gap-5 justify-content-center align-items-center">
              <WeeklyCalendar
                selectedDate={formData.selectedDate}
                onDateSelect={handleDateSelect}
                availableSlots={availableSlots}
              />
              {formData.selectedDate && (
                <TimeSlots
                  timeSlots={formData.selectedTimeSlots}
                  onTimeSlotSelect={handleTimeSlotSelect}
                />
              )}
              {carCount > 0 && <div className="mt-4"></div>}
            </div>
          </div>
        )}

        {currentStep === 4 && (
          <div>
            <h2
              className="h2 mb-6"
              style={{ color: "#ee373b", margin: "15px 0px" }}
            >
              Set {eventType === "pre-approved" ? "Approval Limit" : "Max Range"} & Duration
            </h2>
            <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
              <div className="mb-3">
                <label htmlFor="approvalLimit" className="form-label">
                  {eventType === "pre-approved" ? "Approval Limit" : "Max Range"}
                </label>
                <select
                  id="approvalLimit"
                  value={formData.approvalLimit}
                  style={{ maxWidth: "300px" }}
                  onChange={handleApprovalLimitChange}
                  className="form-select"
                >
                  <option value="">Select {eventType === "pre-approved" ? "Pre-Approval Limit" : "Max Range"}</option>
                  {APPROVAL_RANGES.map((range) => (
                    <option key={range.id} value={range.value}>
                      {range.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="duration" className="form-label">
                  Duration of Event
                </label>
                <select
                  id="duration"
                  value={formData.duration}
                  onChange={handleDurationChange}
                  style={{
                    maxWidth: "300px",
                    maxHeight: "100px",
                    overflowY: "auto",
                    scrollbarColor: "#ee373b #ffffff",
                  }}
                  className="form-select"
                >
                  <option value="">Select Duration</option>
                  {durationOptions.length > 0 ? (
                    durationOptions.map((duration) => (
                      <option key={duration.id} value={duration.value}>
                        {duration.label}
                      </option>
                    ))
                  ) : (
                    <>
                      <option value="5">5 Mins</option>
                      <option value="10">10 Mins</option>
                      <option value="15">15 Mins</option>
                      <option value="30">30 Mins</option>
                      <option value="45">45 Mins</option>
                      <option value="60">1 Hour</option>
                      <option value="120">2 Hours</option>
                      <option value="180">3 Hours</option>
                      <option value="240">4 Hours</option>
                    </>
                  )}
                </select>
              </div>
            </div>
          </div>
        )}

        {currentStep === 5 && (
          <div className="container py-3">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <span className="d-none d-lg-block" style={{width: "100px"}}></span>

              <h2 className="mb-0 d-none d-lg-block" style={{ color: "#ee373b" }}>
                Add Customer Data
              </h2>
              {/* Mobile / small to medium screens (below lg) */}
              <h5 className="mb-0 d-block d-lg-none" style={{ color: "#ee373b" }}>
                Add Customer Data
              </h5>
              {/* Single Toggle Button */}
              <button
                className="btn btn-danger"
                style={{width: "100px"}}
                onClick={() =>
                  {
                    setInputMethod(inputMethod === "manual" ? "excel" : "manual")
                    setUsers([]);
                  }
                }
              >
                {inputMethod === "manual"
                  ? "Excel Upload"
                  : "Manual Input"}
              </button>
            </div>
            {/* Manual Input Section */}
            {inputMethod === "manual" && (
              <div className="p-2 mb-1">
                <div className="d-flex align-items-end d-flex justify-content-center">
                  <div className="col-md-5">
                    <input
                      type="text"
                      className="form-control"
                      id="userID"
                      value={newUser.userID}
                      onChange={(e) =>
                        setNewUser({ ...newUser, userID: e.target.value })
                      }
                      placeholder="Enter customer ID"
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-danger"
                      onClick={handleAddUser}
                      disabled={
                        !newUser.userID || !newUser.preapprovedLimitValue
                      }
                    >
                      Add User
                    </button>
                  </div>
                </div>
                {errorMessage && (
                  <div className="alert alert-danger mt-3">{errorMessage}</div>
                )}
              </div>
            )}
            {/* Excel Upload Section */}
            {inputMethod === "excel" && (
              <div className="p-1 mb-1 d-flex justify-content-center">
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={handleFileUpload}
                  className="form-control mb-3"
                />
              </div>
            )}
            {/* Added Customers Table */}
            {users.length > 0 && (
              <div className="p-1">
                <h4 className="fw-semibold mb-1">Added Customers</h4>
                <div style={{ maxHeight: "28vh", overflowY: "auto", scrollbarColor: "#ee373b #ffffff" }}>
                  <table className="table table-hover align-middle">
                    <thead className="table-light sticky-top">
                      <tr>
                        <th>Customer Ref ID</th>
                        <th>Preapproved Loan Value</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user, index) => (
                        <tr key={index}>
                          <td>{user.userID}</td>
                          <td>{user.preapprovedLimitValue}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => {
                                const updatedUsers = [...users];
                                updatedUsers.splice(index, 1);
                                setUsers(updatedUsers);
                              }}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {currentStep === 6 && !isComplete && (
          <div>
            <h2
              className="h2 mb-6"
              style={{ color: "#ee373b", margin: "15px 0px" }}
            >
              Review & Create Event
            </h2>
            <div className="space-y-4">
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                Event Type:{" "}
                {EVENT_TYPES.find((t) => t.value === vehicleType)?.label ||
                  vehicleType}
              </p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                Date: {formData.selectedDate?.toLocaleDateString()}
              </p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                Selected Time Slots:{" "}
                {formData.selectedTimeSlots
                  ?.filter((slot) => slot.selected)
                  .map((slot) => slot.time)
                  .join(", ")}
              </p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                {eventType === "pre-approved" ? "Approval Limit" : "Max Range"}:{" "}
                {
                  APPROVAL_RANGES.find(
                    (range) => range.value === formData.approvalLimit
                  )?.label
                }
              </p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                Location: {location}
              </p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                Duration:{" "}
                {durationOptions.length > 0
                  ? durationOptions.find(
                      (duration) => duration.value === formData.duration
                    )?.label
                  : `${formData.duration} Mins`}
              </p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                Selected People: {users.length} customers
              </p>
            </div>
          </div>
        )}

        {isComplete && (
          <div className="text-center mt-5">
            <div
              className="d-inline-flex justify-content-center align-items-center bg-white mb-4"
              style={{
                width: "4rem",
                height: "4rem",
                border: "1px solid #ee373b",
                borderRadius: "4rem",
              }}
            >
              <Check className="w-8 h-8 text-danger bg-white" />
            </div>
            <h2 className="h2 mb-2">Event Created Successfully!</h2>
            <p className="text-muted">
              Your event has been scheduled and invitations will be sent to the
              selected participants.
            </p>
            {link.length > 0 ? (
              <TextDisplayCopy link={link} />
            ) : (
              <button
                onClick={() => navigate("/lenderEvent")}
                className="btn btn-danger mt-3"
              >
                Manage Events
              </button>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-vh-100 align-items-center p-4">
      <div
        className="w-100 max-w-4xl bg-white overflow-hidden position-relative"
        style={{
          minHeight: "75vh",
          maxHeight: "75vh",
          borderRadius: "20px",
          border: "2px solid red",
        }}
      >
        <div style={{ backgroundColor: "#ee373b", padding: "5px" }}>
          <h2 style={{ color: "white", fontWeight: "bold" }}>
            Create Event for Private Lender
          </h2>
        </div>
        <div className="h-100 px-3 d-flex flex-column position-relative">
          {renderStep()}
          {!isComplete && (
            <div
              className="d-flex gap-2 justify-content-end p-3 mt-auto position-fixed"
              style={{
                backgroundColor: "rgba(0,0,0,0)",
                top: "calc(50vh + 170px)",
                right: "calc(2vw + 15px)",
              }}
            >
              {currentStep > 1 && (
                <button onClick={handleBack} className="btn btn-outline-danger">
                  Back
                </button>
              )}
              <button
                onClick={handleNext}
                className="btn btn-danger"
                disabled={!isStepValid || (currentStep === 6 && isCreating)}
              >
                {currentStep === 6
                  ? isCreating
                    ? "Creating..."
                    : "Create Event"
                  : "Next"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivateLenderEventCreation;